const l = [
  "beacon-area-chart",
  "beacon-article-tile",
  "beacon-bio-card",
  "beacon-button",
  "beacon-bar-chart",
  "beacon-byline",
  "beacon-carousel",
  "beacon-chart-tooltip",
  "beacon-chart-tooltip-data",
  "beacon-checkbox",
  "beacon-collection-tile",
  "beacon-contact-tile",
  "beacon-country",
  "beacon-country-selector",
  "beacon-data-list",
  "beacon-date-picker",
  "beacon-donut-chart",
  "beacon-dropdown",
  "beacon-error",
  "beacon-error-message-summary",
  "beacon-footer",
  "beacon-gauge-chart",
  "beacon-hero",
  "beacon-icon-button",
  "beacon-id-card",
  "beacon-input-button-field",
  "beacon-input-field",
  "beacon-key-facts",
  "beacon-legacy-collection-tile",
  "beacon-legend",
  "beacon-legend-item",
  "beacon-line-chart",
  "beacon-modal",
  "beacon-navigation",
  "beacon-navigation-button",
  "beacon-navigation-expanded",
  "beacon-navigation-footer",
  "beacon-navigation-popover",
  "beacon-navigation-toolbelt",
  "beacon-paginated-tabs",
  "beacon-popover",
  "beacon-promo-tile",
  "beacon-quote-block",
  "beacon-radio-button",
  "beacon-radio-group",
  "beacon-region-selector",
  "beacon-scatter-chart",
  "beacon-social-link",
  "beacon-social-link-container",
  "beacon-stepper",
  "beacon-tab",
  "beacon-tab-panel",
  "beacon-tabbed-hero",
  "beacon-table",
  "beacon-table-caption",
  "beacon-table-header",
  "beacon-table-record",
  "beacon-table-stub",
  "beacon-tabs",
  "beacon-text-area",
  "beacon-toggle-button-field",
  "beacon-tooltip",
  "beacon-value-prop",
  "beacon-video",
  "beacon-video-tag",
  "beacon-video-transcript"
], x = {
  allComponents: l
}, j = (t) => t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (e, a) => (a ? "-" : "") + e.toLowerCase()), g = (t) => /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(t);
function h(t) {
  return `${t}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, a, n) => `${a.toUpperCase() + n}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
const v = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function f(t) {
  switch (t) {
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./register-chunks/index-26906006.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./register-chunks/index-a20dd3e8.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./register-chunks/index-7d7754ec.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./register-chunks/index-92c6669e.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./register-chunks/index-82db2067.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./register-chunks/index-380c10c5.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./register-chunks/index-0da343fc.js");
    case "./__temp-separated/beacon-chart-tooltip/index.js":
      return import("./register-chunks/index-4b296bb7.js");
    case "./__temp-separated/beacon-chart-tooltip-data/index.js":
      return import("./register-chunks/index-a454710a.js");
    case "./__temp-separated/beacon-checkbox/index.js":
      return import("./register-chunks/index-73c2d9bd.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./register-chunks/index-ffa12993.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./register-chunks/index-863c0380.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./register-chunks/index-1db3f53f.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./register-chunks/index-38843ab2.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./register-chunks/index-aa10a7de.js");
    case "./__temp-separated/beacon-date-picker/index.js":
      return import("./register-chunks/index-e348e7e2.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./register-chunks/index-f72972b4.js");
    case "./__temp-separated/beacon-dropdown/index.js":
      return import("./register-chunks/index-aa919fbb.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./register-chunks/index-27390162.js");
    case "./__temp-separated/beacon-error-message-summary/index.js":
      return import("./register-chunks/index-b56a13c5.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./register-chunks/index-4e4704b0.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./register-chunks/index-8b2a22ac.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./register-chunks/index-1bcf8f6c.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./register-chunks/index-4e0831f1.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./register-chunks/index-2d489cf7.js");
    case "./__temp-separated/beacon-input-button-field/index.js":
      return import("./register-chunks/index-0cd8d686.js");
    case "./__temp-separated/beacon-input-field/index.js":
      return import("./register-chunks/index-0c4f0287.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./register-chunks/index-d531c2d5.js");
    case "./__temp-separated/beacon-legacy-collection-tile/index.js":
      return import("./register-chunks/index-f4a9c136.js");
    case "./__temp-separated/beacon-legend/index.js":
      return import("./register-chunks/index-aeeccfe9.js");
    case "./__temp-separated/beacon-legend-item/index.js":
      return import("./register-chunks/index-d8854b65.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./register-chunks/index-b3fbece9.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./register-chunks/index-ce00d821.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./register-chunks/index-b27669b1.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./register-chunks/index-b27669b1.js").then((e) => e.index$1);
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./register-chunks/index-b27669b1.js").then((e) => e.index$2);
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./register-chunks/index-1f723efe.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./register-chunks/index-b27669b1.js").then((e) => e.index$3);
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./register-chunks/index-b27669b1.js").then((e) => e.index$4);
    case "./__temp-separated/beacon-paginated-tabs/index.js":
      return import("./register-chunks/index-1139bc39.js");
    case "./__temp-separated/beacon-popover/index.js":
      return import("./register-chunks/index-6699e071.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./register-chunks/index-5e6124e3.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./register-chunks/index-12f38eca.js");
    case "./__temp-separated/beacon-radio-button/index.js":
      return import("./register-chunks/index-f38cc2b6.js");
    case "./__temp-separated/beacon-radio-group/index.js":
      return import("./register-chunks/index-2ad64b48.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./register-chunks/index-7918e6d1.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./register-chunks/index-a76ca418.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./register-chunks/index-c694cb90.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./register-chunks/index-076f4df0.js");
    case "./__temp-separated/beacon-stepper/index.js":
      return import("./register-chunks/index-9450296a.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./register-chunks/index-5c9f216b.js");
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./register-chunks/index-15495064.js");
    case "./__temp-separated/beacon-tabbed-hero/index.js":
      return import("./register-chunks/index-d534abb2.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./register-chunks/index-9f047013.js");
    case "./__temp-separated/beacon-table-caption/index.js":
      return import("./register-chunks/index-01ba2d7a.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./register-chunks/index-ed24087a.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./register-chunks/index-cf992500.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./register-chunks/index-4fb5ac76.js").then((e) => e.index);
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./register-chunks/index-6a2fd574.js");
    case "./__temp-separated/beacon-text-area/index.js":
      return import("./register-chunks/index-9983ddd5.js");
    case "./__temp-separated/beacon-toggle-button-field/index.js":
      return import("./register-chunks/index-d5ba00b7.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./register-chunks/index-29dd16fc.js");
    case "./__temp-separated/beacon-value-prop/index.js":
      return import("./register-chunks/index-2baf16e1.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./register-chunks/index-73d0a63b.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./register-chunks/index-2b275922.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./register-chunks/index-5ae04c5b.js");
    default:
      return new Promise(function(e, a) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
          a.bind(null, new Error("Unknown variable dynamic import: " + t))
        );
      });
  }
}
const m = async (t = "", e = document.body) => {
  const a = t ? t + "-beacon-" : "beacon-", n = e instanceof Element ? e.tagName.toLowerCase() : "", c = n == null ? void 0 : n.startsWith(a), s = [...e.querySelectorAll(":not(:defined)")].map((r) => r.tagName.toLowerCase()).filter((r) => r.startsWith(a));
  c && !customElements.get(n) && s.push(n);
  const o = [...new Set(s)].map((r) => t ? r.split(`${t}-`)[1] : r);
  o.length && await C(t, o);
}, w = (t) => {
  const e = j(t);
  return g(t) || console.warn(
    `Beacon Warning: '${t}' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name "${e}".`
  ), e;
}, y = (t) => {
  const e = w(t);
  return {
    tagName: e,
    className: h(e)
  };
}, p = async (t, e, a) => new Promise((n, c) => {
  var s;
  if (typeof e == "string") {
    const { tagName: o, className: r } = y(e), d = t ? `${t}-${o}` : o;
    customElements.get(d) ? n(customElements.get(d)) : f(`./__temp-separated/${o}/index.js`).then((_) => {
      var b;
      const i = _[`${r}`];
      i.registerComponent(t), (b = i.nestedComponents) != null && b.length && Promise.all(
        i.nestedComponents.map(
          (u) => p(t, u, a)
        )
      ), n(i);
    }).catch(() => {
      a && c(new Error(`Beacon Registration Error: Unable to import ${e}`));
    });
  } else if (e.registerComponent) {
    const o = e;
    o.registerComponent(t), (s = o.nestedComponents) != null && s.length && Promise.all(
      o.nestedComponents.map(
        (r) => p(t, r, a)
      )
    ), n(o);
  }
}), C = async (t = "", e = [], a = !v) => {
  const n = e.length ? e : x.allComponents;
  await Promise.all(
    n.map(
      (c) => p(t, c, a)
    )
  );
}, k = async (t = "") => {
  const e = new MutationObserver(async (a) => {
    for (const { addedNodes: n } of a)
      for (const c of n)
        c.nodeType === Node.ELEMENT_NODE && await m(t, c);
  });
  return await m(t), e.observe(document.documentElement, { subtree: !0, childList: !0 }), e;
};
export {
  k as autoLoadBeaconComponents,
  y as getComponentIdentifiers,
  w as getComponentTagName,
  p as importAndRegisterComponent,
  C as registerBeaconComponents
};
